import { Tweet } from '@pauliescanlon/gatsby-mdx-embed';
import * as React from 'react';
export default {
  Tweet,
  React
};